import { createTokensFromScale } from '../../utils/createTokensFromScale';
export const defaultLineHeightScale = {
    prefix: 'twist-core-line-height',
    steps: {
        base: { size: 1, unit: '%' },
        80: { multiplier: 80 },
        90: { multiplier: 90 },
        100: { multiplier: 100 },
        105: { multiplier: 105 },
        110: { multiplier: 110 },
        115: { multiplier: 115 },
        120: { multiplier: 120 },
        125: { multiplier: 125 },
        130: { multiplier: 130 },
        140: { multiplier: 140 },
        150: { multiplier: 150 },
        160: { multiplier: 160 }
    }
};
// generates the following tokens:
// export const defaultLineHeightTokens = {
//   'twist-core-line-height-base': '1%',
//   'twist-core-line-height-80': 'calc(80 * var(--twist-core-line-height-base))',
//   'twist-core-line-height-90': 'calc(90 * var(--twist-core-line-height-base))',
//   'twist-core-line-height-100': 'calc(100 * var(--twist-core-line-height-base))',
//   'twist-core-line-height-105': 'calc(105 * var(--twist-core-line-height-base))',
//   'twist-core-line-height-110': 'calc(110 * var(--twist-core-line-height-base))',
//   'twist-core-line-height-115': 'calc(115 * var(--twist-core-line-height-base))',
//   'twist-core-line-height-120': 'calc(120 * var(--twist-core-line-height-base))',
//   'twist-core-line-height-125': 'calc(125 * var(--twist-core-line-height-base))',
//   'twist-core-line-height-130': 'calc(130 * var(--twist-core-line-height-base))',
//   'twist-core-line-height-140': 'calc(140 * var(--twist-core-line-height-base))',
//   'twist-core-line-height-150': 'calc(150 * var(--twist-core-line-height-base))',
//   'twist-core-line-height-160': 'calc(160 * var(--twist-core-line-height-base))'
// }
export const defaultLineHeightTokens = createTokensFromScale(defaultLineHeightScale);
